import Axios from './Axios';

class ReportsService {

  listAll(payload, watchmanId = null) {
    return Axios({
      method: "GET",
      url: "visitor_reports?search_term=" + payload.search_term + "&per_page=" + payload.options?.itemsPerPage + "&page=" + payload.options?.page + "&watchman_id=" + watchmanId + "&" + this.generateUrlParams(payload.filters),
    })
  }

  generateUrlParams(obj) {
    var str = "";

    for (var key in obj) {
      if (str != "") {
          str += "&";
      }
      str += key + "=" + encodeURIComponent(obj[key]);
    }

    return str;
  }

  upcomingVisits(organization_id, payload) {
    const page = payload.options?.page || 1;
    const perPage = payload.options?.itemsPerPage || 20;
    const statusFilter = payload.status_filter || 'all';
    return Axios({
      method: "GET",
      url: "organization_upcoming_visits/" + organization_id
        + '?page=' + page
        + '&per_page=' + perPage
        + '&status_filter=' + encodeURIComponent(statusFilter)
    });
  }

  pastVisits(organization_id, payload) {
    const page = payload.options?.page || 1;
    const perPage = payload.options?.itemsPerPage || 20;
    const statusFilter = payload.status_filter || 'all';
    return Axios({
      method: "GET",
      url: "organization_past_visits/" + organization_id
        + '?page=' + page
        + '&per_page=' + perPage
        + '&status_filter=' + encodeURIComponent(statusFilter)
    });
  }

  smsLogs(organisation_id, payload) {
    return Axios({
      method: "GET",
      url: "sms-logs/" + organisation_id + '?page=' + payload.options?.page + '&per_page=' + payload.options?.itemsPerPage
    });
  }
}

export default new ReportsService()
